import React, { ReactNode, createContext, useEffect, useState } from 'react';

interface MyContextValue {
    myState: string;
    setMyState: React.Dispatch<React.SetStateAction<string>>;
    addSecondaryUser: boolean;
    setAddSecondaryUser: React.Dispatch<React.SetStateAction<boolean>>;
    setRedirectUrlState : (url:string)=>void
}


export const MyContext = createContext<MyContextValue | undefined>(undefined);

const MyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [myState, setMyState] = useState<string>('');
  const [addSecondaryUser, setAddSecondaryUser] = useState<boolean>(false);

  useEffect(()=>{
    const url =  localStorage.getItem('redirectUrl');
    setMyState(url);
  },[])


  const setRedirectUrlState = (url) =>{
    setMyState(url);
      localStorage.setItem('redirectUrl',url);
  
  }
  const contextValue: MyContextValue = {
    myState,
    setMyState,
    addSecondaryUser,
    setAddSecondaryUser,
    setRedirectUrlState
  };

  return (
    <MyContext.Provider value={contextValue}>
      {children}
    </MyContext.Provider>
  );
};
  export default MyProvider;
